import Component from '@glimmer/component';
import { HdsAlert } from '@hashicorp/design-system-components/components';
import { t } from 'ember-intl';

/**
 *
 * ```
 * <Sso::Banner::DefaultRoleOrgLockoutConfirmation />
 * ```
 *
 * @class SsoBannerDefaultRoleOrgLockoutConfirmation
 *
 */
export default class SsoBannerDefaultRoleOrgLockoutConfirmation extends Component {
  <template>
    <HdsAlert
      data-test-sso-banner-default-role-org-lockout-confirmation
      @type="compact"
      @color="warning"
      as |A|
    >
      <A.Description>
        {{t "sso.banner.default-role-org-lockout-confirmation.description"}}
      </A.Description>
    </HdsAlert>
  </template>
}
